import Ac2WarehouseProvider from '@/resources/Ac2WarehouseProvider'

const Ac2WarehouseService = new Ac2WarehouseProvider()

// cache ผล wms-managed ร่วมกันทุกแถว/ทุกหน้า กันยิง API ซ้ำ (mapping warehouse เปลี่ยนไม่บ่อย)
const CACHE_TTL = 5 * 60 * 1000
const willSyncCache = new Map()

// DN (inbound): ของเข้า warehouse ของเอกสาร (destination) จาก warehouse ของ WN ต้นทาง (source)
// WN (outbound): ของออกจาก warehouse ของเอกสาร (source) ไป warehouse ของ DN ปลายทาง (destination)
export const getAc2SyncParams = (type, note) => {
  const noteWarehouseId = note?.warehouse?.id
  if (type === 'DeliveryNote') {
    return {
      source: note?.withdrawNoteRef?.warehouseId || undefined,
      destination: noteWarehouseId || undefined,
      reason: note?.reason
    }
  }

  return {
    source: noteWarehouseId || undefined,
    destination: note?.deliveryNoteRef?.warehouseId || undefined,
    reason: note?.reason
  }
}

// ใช้ rule เดียวกับตอน sync จริงฝั่ง backend: warehouse ภายใต้ AC2, โอนย้ายภายใน AC2, refund warehouse และ reason
export const checkNoteWillSync = (type, note) => {
  const params = getAc2SyncParams(type, note)
  if (!params.reason) {
    return Promise.resolve(false)
  }

  const key = `${type}|${params.source || ''}|${params.destination || ''}|${params.reason}`
  const cached = willSyncCache.get(key)
  if (cached && Date.now() - cached.at < CACHE_TTL) {
    return cached.promise
  }

  const promise = Ac2WarehouseService.getWmsManaged(params)
    .then(({ data }) => {
      const result = type === 'DeliveryNote' ? data?.deliveryNote : data?.withdrawNote
      return !!result?.willSync
    })
    .catch((error) => {
      console.error('checkNoteWillSync', error)
      willSyncCache.delete(key)
      return false
    })

  willSyncCache.set(key, { promise, at: Date.now() })
  return promise
}

export default {
  getAc2SyncParams,
  checkNoteWillSync
}
